import { JourneyDetailsStepper, JourneyDetailsWizard, MobileSidebarDrawer } from "../components";
import CountdownTimerSlider from "@Components/CountdownTimerSlider/CountdownTimerSlider";
export default function JourneyDetailsMob() {

  return (
    <div className="relative flex w-full flex-col">
      <div className="flex w-full flex-1 items-center">
        <div className="border-border-default flex w-full bg-background-default flex-1 items-center justify-center gap-4 justify-self-center border-b p-4">
          <JourneyDetailsStepper />
        </div>
      </div>

      <div className="flex w-full flex-col gap-y-4 bg-background-minimal min-h-[80dvh]" style={{ paddingBottom: 50 }}>
        <div className="sticky top-0 z-30">
          <CountdownTimerSlider />
        </div>
        <div className="flex w-full flex-col px-4">
          <JourneyDetailsWizard />
        </div>
      </div>
      <div className="bottom-0">
        <MobileSidebarDrawer />
      </div>
    </div>
  );
}
